


















import ZenyaDialog, { ZenyaDialogComponent, ZenyaDialogInjects } from "./ZenyaDialog.vue";
import storeHelper from "@/store/store-helper";
import { ConfirmationParameters } from "@/store/modules/readList/read-list";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "Reason",
    props: {
        documentId: String,
        readConfirmationId: Number
    },
    data: function () {
        return {
            reason: ""
        };
    },
    components: { ZenyaDialog },
    created() {
        //register handler for dialog OK button
        this.registerHandlers({ ok: this.confirmAsync, cancel: this.cancel });
    },
    methods: {
        async confirmAsync(): Promise<boolean> {
            let result = await storeHelper.readListStore.updateReadConfirmation({
                read_confirmation_id: this.readConfirmationId,
                document: {
                    document_id: this.documentId
                },
                reason_for_not_applicable: this.reason
            } as ConfirmationParameters);

            if (result.success) {
                this.$emit("ok-not-applicable");
                return true;
            }

            return false;
        },

        async cancel(): Promise<boolean> {
            this.$emit("cancel");
            return true;
        }
    }
});
